/** Documentatie + voorbeelden voor template-variabelen (HTML, plain text, blocks). */
export const TEMPLATE_VARIABLE_CATALOG = [
    {
        key: 'voornaam',
        label: 'Voornaam contact',
        source: 'lead',
        required: true,
        example: 'Hoi {{voornaam}},',
        html_example: '<p>Hoi {{voornaam}},</p>',
        block_example: 'Hoi {{voornaam}},',
    },
    {
        key: 'company',
        label: 'Bedrijfsnaam',
        source: 'lead',
        required: true,
        example: 'Ik zag {{company}} online…',
        html_example: '<p>Even over <strong>{{company}}</strong>…</p>',
        block_example: 'Ik zag {{company}} en…',
    },
    {
        key: 'email',
        label: 'E-mailadres lead',
        source: 'lead',
        example: 'We mailen je op {{email}}.',
        html_example: '<p>Reply naar {{email}}.</p>',
        block_example: 'Reply naar {{email}}.',
    },
    {
        key: 'merk',
        label: 'Project / merknaam',
        source: 'system',
        example: 'Team {{merk}}',
        html_example: '<p>Groet,<br>{{merk}}</p>',
        block_example: 'Groet,\n{{merk}}',
    },
    {
        key: 'afzender_naam',
        label: 'Afzender (display)',
        source: 'system',
        example: 'Groet,\n{{afzender_naam}}',
        html_example: '<p>Groet,<br>{{afzender_naam}}</p>',
        block_example: 'Groet,\n{{afzender_naam}}',
    },
    {
        key: 'unsubscribe_url',
        label: 'Uitschrijflink (verplicht in campagnes)',
        source: 'system',
        example: 'Uitschrijven: {{unsubscribe_url}}',
        html_example: '<p style="font-size:12px;color:#64748b"><a href="{{unsubscribe_url}}">Uitschrijven</a></p>',
        block_example: 'Uitschrijven: {{unsubscribe_url}}',
    },
];
export const DEFAULT_HTML_TEMPLATE_EXAMPLE = `<!DOCTYPE html>
<html lang="nl">
<body style="font-family: system-ui, sans-serif; line-height: 1.5; color: #0f172a; max-width: 560px;">
  <p>Hoi {{voornaam}},</p>
  <p>
    Ik zag <strong>{{company}}</strong> en vroeg me af of jullie openstaan voor
    <em>[jouw concrete voorstel — vul dit zelf in]</em>.
  </p>
  <p>Heb je 15 minuten voor een kort belletje?</p>
  <p>Groet,<br>{{afzender_naam}} · {{merk}}</p>
  <p style="font-size: 12px; color: #64748b;">
    <a href="{{unsubscribe_url}}">Uitschrijven</a>
  </p>
</body>
</html>`;
export const DEFAULT_PLAIN_TEMPLATE_EXAMPLE = `Hoi {{voornaam}},

Ik zag {{company}} en vroeg me af of jullie openstaan voor [jouw voorstel].

Heb je 15 minuten voor een belletje?

Groet,
{{afzender_naam}}`;
export function templateVariableToken(key) {
    return `{{${key}}}`;
}
//# sourceMappingURL=templateVariableGuide.js.map